/**
 * Figma container tokens (1x = 4px): padding-x Spacing/4x (16px), padding-y Spacing/2x (8px),
 * internal gap Spacing/2x (8px). Size M/S only changes typography and icon scale.
 * @type {Record<'md' | 'sm', { container: string; iconSize: number }>}
 */
export const TAB_SIZE_TOKENS = {
  md: {
    container: 'gap-2 px-4 py-2 text-base',
    iconSize: 24,
  },
  sm: {
    container: 'gap-2 px-4 py-2 text-sm',
    iconSize: 20,
  },
};

/**
 * @param {{ selected: boolean; disabled: boolean }} options
 * @returns {string}
 */
export function tabToneClasses({ selected, disabled }) {
  if (disabled) {
    return selected
      ? 'cursor-not-allowed border-[#2173FF]/35 text-[#2173FF]/35 dark:border-blue-400/35 dark:text-blue-400/35'
      : 'cursor-not-allowed border-transparent text-[#BABABA] dark:text-white/30';
  }

  if (selected) {
    return [
      'border-[#2173FF] text-[#2173FF]',
      'hover:border-[#002F80] hover:text-[#002F80]',
      'dark:border-blue-400 dark:text-blue-400',
      'dark:hover:border-blue-300 dark:hover:text-blue-300',
    ].join(' ');
  }

  return [
    'border-transparent text-[#2A2A2A]',
    'hover:text-[#5C5C5C]',
    'dark:text-white/60 dark:hover:text-white/80',
  ].join(' ');
}

export const tabRootClass = [
  'relative flex shrink-0 items-center justify-center',
  'border-b-2 font-semibold whitespace-nowrap transition-colors',
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#2173FF]/50 focus-visible:ring-offset-2',
  'disabled:pointer-events-none',
].join(' ');

export const tabNavRootClass = 'flex w-full items-start gap-2';

export const tabNavEqualWidthClass = '[&>[role=tab]]:min-w-0 [&>[role=tab]]:flex-1';
